/**
 * 상단 띠 — 프로젝트팀포유의 다른 프로그램·앱·게임 소개.
 *
 * 주소는 한 곳에서만 쓴다(시험이 이 값을 지킨다). 외부 링크는 새 탭 + noopener noreferrer —
 * 게임 판 도중 눌러도 이 탭의 진행(저장 전 상태)을 잃지 않는다.
 */

export const PROMO_URL = 'https://projectteamforyou.com';
export const PROMO_BRAND = '프로젝트팀포유';

/** 넓은 화면 / 좁은 화면(한 줄에 들어가도록 줄인 문구). 둘 다 「만나보고 지지」 뜻을 지킨다. */
export const PROMO_TEXT_LONG = '의 다양한 프로그램 · 앱 · 게임을 만나보시고 지지해주세요';
export const PROMO_TEXT_SHORT = '의 앱 · 게임을 만나보고 지지해주세요';
